exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host /deep/ ag-grid-angular .ag-header-group-cell-label {\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n:host /deep/ .ag-row.ag-row-no-focus.ag-row-odd.ag-row-group.ag-row-level--1.ag-row-footer {\n  font-weight: bold !important; }\n\n:host /deep/ .ag-row.ag-row-no-focus.ag-row-even.ag-row-group.ag-row-level--1.ag-row-footer {\n  font-weight: bold !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/billing-general/billed/summary-grid/summary-grid.component.scss
// module id = 1962
// module chunks = 66